export const WaNumber = '6281324262648';

export const WaLink = `https://wa.me/+${WaNumber}`;
